import { useState, useEffect, useRef, useCallback } from 'react';
import {
    Background,
    Form,
    Title,
    Button,
    CloseIcon,
    RespostaContainer,
    ContentWrapper,
    InputMensagem,
    SendMessage,
    IconSendMessage,
    MessageCoontainer,
    Message,
} from './style';
import InputLabel from '../../InputLabel';
import SelectLabel from '../../SelectLabel';
import Texts from '../../../assets/json/texts.json';
import { Swal } from '../../../services/SwalTemplates';
import { userId, email } from '../../../services/TokenData';
import TextareaLabel from '../../TextareaLabel';
import FileInput from '../../FileInput';
import api from '../../../services/api';
import { format } from '../../../services/DateFormatter';
import alert from '../../../utils/alert';
import { HiTrash } from 'react-icons/hi';

export default function EditOcorrencia({ Show, setShow, DadosOcorrencia, Reload, setReload, DadosProcesso }) {
    const [Descricao, setDescricao] = useState('');
    const [IdResponsavel, setIdResponsavel] = useState('');
    const [Situacao, setSituacao] = useState('');
    const [DataPrevista, setDataPrevista] = useState('');
    const [DataConclusao, setDataConclusao] = useState('');
    const [Assunto, setAssunto] = useState('');
    const [ShowFileInput, setShowFileInput] = useState(false);
    const [Anexo, setAnexo] = useState(null);
    const [Responsaveis, setResponsaveis] = useState([]);
    const [IdResponsaveis, setIdResponsaveis] = useState([]);
    const [Resposta, setResposta] = useState('');
    const USER_ID = userId();
    const USER_EMAIL = email();
    const [respostasFormatadas, setRespostasFormatadas] = useState([]);
    const fimRef = useRef(null);

    async function HandleSubmit(e) {
        e.preventDefault();

        // Verificação de dados obrigatórios
        if (!DadosOcorrencia?.id_processo || !DadosOcorrencia?.seq_ocorrencia) {
            Swal.fire({
                title: 'Erro!',
                text: 'Dados da ocorrência incompletos',
                icon: 'error',
            });
            return;
        }

        // Construção do payload
        const data = {
            descricao: Descricao,
            id_usuario_acao: USER_ID,
            id_destinatario: Number(IdResponsavel) || DadosOcorrencia.id_destinatario,
            resposta: Resposta,
            resposta_anterior: DadosOcorrencia?.resposta,
            situacao: Situacao || DadosOcorrencia.situacao,
            nivel_ocorrencia: DadosOcorrencia?.nivel_ocorrencia,
            data_prevista: DataPrevista || format({ DataInicial: new Date(DadosOcorrencia.data_prevista), Formato: 'YYYY-MM-DD' }),
            data_conclusao: ['Concluído', 'Cancelado'].includes(Situacao)
                ? DataConclusao || format({ DataInicial: new Date(), Formato: 'YYYY-MM-DD' })
                : null,
            email_remetente: USER_EMAIL || '',
        };

        try {
            await api.patch(`/ocorrencias/${DadosOcorrencia.id_processo}/${DadosOcorrencia.seq_ocorrencia}/${DadosOcorrencia?.nivel_ocorrencia}`, {
                data,
            });
            if (Anexo) {
                const formData = new FormData();
                formData.append('file', Anexo);
                formData.append('assunto_documento', Assunto);

                await api.post(
                    `/anexos?processo=${DadosOcorrencia.id_processo}&seq_ocorrencia=${DadosOcorrencia.seq_ocorrencia}&nivel_ocorrencia=${DadosOcorrencia.nivel_ocorrencia}`,
                    formData
                );
            }

            alert(
                'Sucesso-popup',
                `${data.nivel_ocorrencia === 0 ? 'Ocorrência' : 'Subocorrência'} atualizada com sucesso!`,
                4000,
                '',
                '',
                'top-end',
                'fit-content'
            );

            close();
            setReload(!Reload);
        } catch (error) {
            alert(
                'Erro-popup',
                `Erro ao atualizar ${data.nivel_ocorrencia === 0 ? 'ocorrência' : 'subocorrência'}!`,
                4000,
                '',
                '',
                'top-end',
                'fit-content'
            );
            console.error(error);
        }
    }

    async function handleEnviarMensagem() {
        if (!Resposta || Resposta.trim() === '') {
            return;
        }

        const data = {
            resposta: Resposta,
            resposta_anterior: DadosOcorrencia?.resposta,
            email_remetente: USER_EMAIL || '',
        };

        try {
            const res = await api.patch(
                `/ocorrencias/mensagem/${DadosOcorrencia.id_processo}/${DadosOcorrencia.seq_ocorrencia}/${DadosOcorrencia?.nivel_ocorrencia}`,
                { data }
            );
            if (res.status === 200) {
                setRespostasFormatadas((prev) => {
                    const novaRes = {
                        email: USER_EMAIL,
                        conteudo: `${Resposta} (${format({ DataInicial: new Date(), Formato: 'DD/MM/YYYYTHH:mm:ss' }).replace('-', ', ')})`,
                    };
                    return [...prev, novaRes];
                });
                setResposta('');
            }
            // Close();
            setReload(!Reload);
        } catch (error) {
            console.error(error);
        }
    }

    const close = () => {
        setDescricao('');
        setSituacao('');
        setIdResponsavel('');
        setDataPrevista('');
        setDataConclusao('');
        setResposta('');
        setAnexo('');
        setShowFileInput(false);
        setShow(false);
        setResposta([]);
        setRespostasFormatadas([]);
        setAssunto('');
    };

    const getResponsavelAtual = () => {
        const index = IdResponsaveis.findIndex((id) => id === DadosOcorrencia?.id_destinatario);
        return index !== -1 ? Responsaveis[index] : '';
    };

    const getResposta = useCallback(() => {
        if (!DadosOcorrencia?.resposta) {
            setRespostasFormatadas([]);
            return [];
        }

        const arrayDeRespostas = DadosOcorrencia.resposta.split('<!>');
        const parEmailEConteudo = [];

        // Corrigido: loop deve ir até length-1, não length-2
        for (let i = 0; i < arrayDeRespostas.length - 1; i += 2) {
            const email = arrayDeRespostas[i]?.trim() || '';
            const conteudo = arrayDeRespostas[i + 1]?.trim() || '';

            // Só adiciona se ambos existirem
            if (email && conteudo) {
                parEmailEConteudo.push({ email, conteudo });
            }
        }

        setRespostasFormatadas(parEmailEConteudo);
        return parEmailEConteudo;
    }, [DadosOcorrencia?.resposta]);

    const dataMinima = () => {
        const dataRaw = DadosOcorrencia?.data_emissao;
        if (!dataRaw) return '';

        // Se for uma string, dividir normalmente
        if (typeof dataRaw === 'string') {
            const [dia, mes, ano] = dataRaw.split('/').map(Number);
            const data = new Date(ano, mes - 1, dia);
            return data.toLocaleDateString('en-CA'); // → 'YYYY-MM-DD'
        }

        // Se for Date, formatar direto
        if (dataRaw instanceof Date) {
            return dataRaw.toLocaleDateString('en-CA');
        }

        // Caso inesperado
        return '';
    };

    const dataMaxima = () => {
        const dataRaw = new Date();
        if (!dataRaw) return '';

        // Se for uma string, dividir normalmente
        if (typeof dataRaw === 'string') {
            const [dia, mes, ano] = dataRaw.split('/').map(Number);
            const data = new Date(ano, mes - 1, dia);
            return data.toLocaleDateString('en-CA'); // → 'YYYY-MM-DD'
        }

        // Se for Date, formatar direto
        if (dataRaw instanceof Date) {
            return dataRaw.toLocaleDateString('en-CA');
        }

        // Caso inesperado
        return '';
    };

    useEffect(() => {
        fimRef.current?.scrollIntoView({ behavior: 'smooth' }); // ou 'auto'
    }, [DadosOcorrencia?.resposta, Show, respostasFormatadas]);

    useEffect(() => {
        if (Show && DadosOcorrencia?.resposta) {
            getResposta();
        }
    }, [Show, DadosOcorrencia?.resposta, getResposta]);

    useEffect(() => {
        if (Show && DadosOcorrencia) {
            setDescricao(DadosOcorrencia?.descricao || '');
            setSituacao(DadosOcorrencia?.situacao || '');
            setIdResponsavel(DadosOcorrencia?.id_destinatario || '');

            // Versão simplificada para teste
            if (DadosOcorrencia?.data_prevista) {
                const dataStr = DadosOcorrencia.data_prevista.toString();

                // Se já está no formato YYYY-MM-DD
                if (dataStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
                    setDataPrevista(dataStr);
                }
                // Se está no formato DD/MM/YYYY
                else if (dataStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                    const [dia, mes, ano] = dataStr.split('/');
                    setDataPrevista(`${ano}-${mes}-${dia}`);
                }
                // Tenta converter como Date
                else {
                    const data = new Date(dataStr);
                    if (!isNaN(data.getTime())) {
                        const year = data.getFullYear();
                        const month = String(data.getMonth() + 1).padStart(2, '0');
                        const day = String(data.getDate()).padStart(2, '0');
                        setDataPrevista(`${year}-${month}-${day}`);
                    } else {
                        console.error('Data inválida:', dataStr);
                        setDataPrevista('');
                    }
                }
            } else {
                setDataPrevista('');
            }

            // Mesma lógica para data de conclusão...
            if (DadosOcorrencia?.data_conclusao) {
                const dataStr = DadosOcorrencia.data_conclusao.toString();

                if (dataStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
                    setDataConclusao(dataStr);
                } else if (dataStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                    const [dia, mes, ano] = dataStr.split('/');
                    setDataConclusao(`${ano}-${mes}-${dia}`);
                } else {
                    const data = new Date(dataStr);
                    if (!isNaN(data.getTime())) {
                        const year = data.getFullYear();
                        const month = String(data.getMonth() + 1).padStart(2, '0');
                        const day = String(data.getDate()).padStart(2, '0');
                        setDataConclusao(`${year}-${month}-${day}`);
                    } else {
                        const hoje = new Date();
                        const year = hoje.getFullYear();
                        const month = String(hoje.getMonth() + 1).padStart(2, '0');
                        const day = String(hoje.getDate()).padStart(2, '0');
                        setDataConclusao(`${year}-${month}-${day}`);
                    }
                }
            } else {
                const hoje = new Date();
                const year = hoje.getFullYear();
                const month = String(hoje.getMonth() + 1).padStart(2, '0');
                const day = String(hoje.getDate()).padStart(2, '0');
                setDataConclusao(`${year}-${month}-${day}`);
            }
        }
    }, [Show, DadosOcorrencia]);

    useEffect(() => {
        async function loadResponsaveis() {
            try {
                const response = await api.get(`/user/usuarios`);
                const usuariosFiltrados = response.data.usuarios.filter((u) => u.perfil !== 'ADM');
                setResponsaveis(usuariosFiltrados.map((r) => r.nome));
                setIdResponsaveis(usuariosFiltrados.map((r) => r.id));
            } catch (error) {
                console.error('Erro ao carregar responsáveis:', error);
            }
        }
        loadResponsaveis();
        getResposta();
    }, []);

    return (
        <Background Show={Show}>
            <Form onSubmit={HandleSubmit}>
                <CloseIcon onClick={close} />
                <Title>Ocorrência</Title>
                <ContentWrapper>
                    <div
                        style={{
                            width: '50%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            gap: '15px',
                            alignItems: 'center',
                            borderRight: '2px solid',
                            padding: '0px 20px 0px 0px',
                        }}
                    >
                        <TextareaLabel
                            value={Descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                            label="Descrição"
                            id={'ocorrencia-descricao'}
                            disabled={DadosOcorrencia?.id_remetente !== USER_ID}
                        />

                        <SelectLabel
                            label="Responsável"
                            value={IdResponsavel}
                            onChange={(e) => setIdResponsavel(e.target.value)}
                            defaultValue={getResponsavelAtual()}
                            options={Responsaveis}
                            values={IdResponsaveis}
                            disabled={DadosOcorrencia?.id_remetente !== USER_ID}
                        />

                        <SelectLabel
                            value={Situacao}
                            onChange={(e) => setSituacao(e.target.value)}
                            label="Situação da Ocorrência"
                            defaultValue={DadosOcorrencia?.situacao}
                            options={Texts?.STATIC_SITUACOES_OCORRENCIAS}
                            values={Texts?.STATIC_SITUACOES_OCORRENCIAS}
                            disabled={DadosOcorrencia?.id_destinatario !== USER_ID}
                        />

                        <InputLabel
                            type="date"
                            value={DataPrevista}
                            onChange={(e) => setDataPrevista(e.target.value)}
                            label="Data Prevista"
                            disabled={!((Situacao || DadosOcorrencia?.situacao) !== 'Concluído' && DadosOcorrencia?.id_remetente === userId())}
                            max={DadosOcorrencia?.dataPrevista}
                        />

                        {(Situacao === 'Concluído' || Situacao === 'Cancelado') && (
                            <InputLabel
                                type="date"
                                value={DataConclusao}
                                onChange={(e) => setDataConclusao(e.target.value)}
                                label={`Data de ${Situacao === 'Concluído' ? 'Conclusão' : 'Cancelamento'}`}
                                min={dataMinima()}
                                max={dataMaxima()}
                            />
                        )}
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            borderRadius: '6px',
                            border: '1px solid',
                            padding: '15px 5px 5px 5px',
                            background: '#d7e5e4',
                            position: 'relative',
                            marginTop: '10px',
                            width: '50%',
                            justifyContent: 'space-between',
                            maxHeight: '50vh',
                        }}
                    >
                        <p
                            style={{
                                position: 'absolute',
                                top: '-10px',
                                left: '10px',
                                textAlign: 'left',
                                width: 'fit-content',
                                backgroundColor: 'black',
                                borderRadius: '4px',
                                color: 'white',
                                padding: '3px 6px',
                                margin: 0,
                                fontSize: '13px',
                                textTransform: 'uppercase',
                                letterSpacing: '1.5px',
                                fontWeight: 500,
                            }}
                        >
                            Mensagens
                        </p>

                        <RespostaContainer>
                            {respostasFormatadas?.map((res, i) => (
                                <MessageCoontainer key={i} ladoMensagem={email() === res?.email}>
                                    <div className="message">
                                        <Message style={{ fontWeight: '600' }}>{res?.email}</Message>
                                        <Message>{res?.conteudo}</Message>
                                    </div>
                                </MessageCoontainer>
                            ))}
                            <div ref={fimRef} />
                        </RespostaContainer>

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'flex-end',
                                minHeight: '35px',
                                borderRadius: '6px',
                                backgroundColor: 'white',
                                position: 'relative',
                                height: 'fit-content',
                            }}
                        >
                            <InputMensagem
                                placeholder="Nova mensagem"
                                value={Resposta}
                                onChange={(e) => {
                                    setResposta(e.target.value);
                                    e.target.style.height = 'auto';
                                    e.target.style.height = Math.min(e.target.scrollHeight, 120) + 'px';
                                }}
                                id="ocorrencia-resposta"
                                rows={1}
                                maxLength={150}
                            />
                            <SendMessage>
                                <IconSendMessage size={20} title="Enviar mensagem" onClick={handleEnviarMensagem} />
                            </SendMessage>
                        </div>
                    </div>
                </ContentWrapper>
                {Anexo && (
                    <span
                        style={{
                            color: 'black',
                            border: '1px solid black',
                            padding: '1%',
                            borderRadius: '3%',
                            display: 'inline-flex',
                            alignItems: 'center',
                        }}
                    >
                        📎 Anexo: {Anexo.name}
                        <HiTrash style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setAnexo(null)} title="Remover anexo" />
                    </span>
                )}
                <div style={{ justifyContent: 'center', alignItems: 'center', gap: '10px', display: 'flex' }}>
                    <Button type="button" onClick={() => setShowFileInput(true)}>
                        Anexar arquivo
                    </Button>
                    <Button type="submit" style={{ background: 'green' }}>
                        Salvar
                    </Button>
                </div>

                <FileInput
                    setShow={setShowFileInput}
                    Show={ShowFileInput}
                    DadosProcesso={DadosProcesso}
                    IdProcesso={DadosOcorrencia?.id_processo}
                    setAnexo={setAnexo}
                    anexo={Anexo}
                    Origin={'Ocorrencia'}
                    Assunto={Assunto}
                    setAssunto={setAssunto}
                />
            </Form>
        </Background>
    );
}
